export const DROPDOWN_LIST = ['VND', 'USD', 'YEN'];
export const DROPDOWN_LIST2 = ['KHR', 'USD', 'YEN'];
export const DROPDOWN_LIST_VND_USD = ['VND', 'USD'];
export const DROPDOWN_LIST_KHR_USD = ['KHR', 'USD'];
